import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/events/components/EventsInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
